export const getApiBase = () => {
  const envBase = (import.meta as any).env?.VITE_API_BASE as string | undefined;
  if (envBase && envBase.trim().length > 0) {
    return envBase.replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    return 'http://127.0.0.1:5001/meihua-16427/us-central1/api';
  }
  return 'https://us-central1-meihua-16427.cloudfunctions.net';
};

export const apiUrl = (path: string) => {
  const apiBase = getApiBase();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return apiBase.endsWith('/api') ? `${apiBase}${cleanPath}` : `${apiBase}/api${cleanPath}`;
};
